import { lazy } from 'react';

/**
 * safeLazy - A wrapper around React.lazy that handles "Failed to fetch" errors.
 * This usually happens when a new version is deployed and the old chunk hashes are gone.
 */
export const safeLazy = (importFn) => {
  return lazy(async () => {
    try {
      return await importFn();
    } catch (error) {
      // If we're in a browser and it's a fetch error, a full reload is often the only cure
      // to get the new manifest and new hashes.
      if (typeof window !== 'undefined' && error.name === 'TypeError') {
        const hasReloaded = sessionStorage.getItem('safeLazy_reloaded');
        if (!hasReloaded) {
          console.warn('Dynamic import failed. Force-refreshing to sync with latest deployment...');
          sessionStorage.setItem('safeLazy_reloaded', 'true');
          window.location.reload();
        } else {
          console.error('Dynamic import failed twice. Breaking infinite reload loop.', error);
          sessionStorage.removeItem('safeLazy_reloaded'); // Reset for next manual attempt
        }
      }
      throw error;
    }
  });
};
